// @flow

import React from 'react';
import {connect} from 'react-redux';
import cs from 'classnames';

import {setAcceptanceStatus} from 'app/acceptance/actions';

import {gt} from 'app/utils/i18n';
import StateButton from 'app/general/widgets/StateButton';
import type {
  AcceptanceStatusType,
  DocumentContentType,
} from 'app/acceptance/types';

type OwnProps = {|
  acceptancestatus: AcceptanceStatusType,
  contentType: DocumentContentType,
  documentId: number,
  className?: string,
|};

type DispatchProps = {|
  setAcceptanceStatus: AsyncAction<typeof setAcceptanceStatus, Promise<any>>,
|};

type Props = {|
  ...OwnProps,
  ...DispatchProps,
|};

type State = {
  disabled: boolean,
};

class BaseConfirmButton extends React.PureComponent<Props, State> {
  state = {
    disabled: false,
  };

  confirm = () => {
    const {setAcceptanceStatus, acceptancestatus, contentType, documentId} =
      this.props;
    this.setState({disabled: true});
    return setAcceptanceStatus(
      acceptancestatus.url,
      true,
      documentId,
      contentType
    ).then(
      () => this.setState({disabled: false}),
      () => this.setState({disabled: false})
    );
  };

  render() {
    let {className, acceptancestatus} = this.props;
    const confirmed = acceptancestatus.status;

    return (
      <StateButton
        className={cs(className || 'btn btn-primary', {active: confirmed})}
        disabled={this.state.disabled || confirmed === true}
        busyText={
          <span className="d-none d-sm-inline">{gt('Confirming...')}</span>
        }
        onClick={() => this.confirm()}
      >
        <i className="fal fa-thumbs-up mr-2" />
        {confirmed ? gt('You confirmed') : gt('Confirm')}
      </StateButton>
    );
  }
}

const mapDispatchToProps: DispatchProps = {
  // $FlowFixMe
  setAcceptanceStatus,
};

export const ConfirmButton = connect<
  Props,
  OwnProps,
  null,
  DispatchProps,
  _,
  _
>(
  null,
  mapDispatchToProps
)(BaseConfirmButton);
